module.exports = __webpack_public_path__ + "static/media/10-4-redcube.ca07e21a.png";